import { render, staticRenderFns } from "./FeaturedCarousel.vue?vue&type=template&id=67a40ca8&"
import script from "./FeaturedCarousel.vue?vue&type=script&lang=js&"
export * from "./FeaturedCarousel.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports